module.exports = __webpack_public_path__ + "media/images/emblems/Engelberg-coat_of_arms_-_2-8e8d26d1ce3a48e1a1b7e004adfbfe84.png";